// extracted by mini-css-extract-plugin
module.exports = {"imgCont":"appGeneration_imgCont__1qqCe","afModuleTitle":"appGeneration_afModuleTitle__b5YK3"};